// extracted by mini-css-extract-plugin
export var equalColumn = "_ih-0";